import React from 'react';
import SelectFileSpinner from './SelectFileSpinner';

const SelectFileInput = ({ onUpload, didUpload, isDisabled }) => {
  function handeUpload(e) {
    e.preventDefault();
    onUpload(e.target.children[0].files[0]);
  }

  const uploadButton = didUpload ? (
      <SelectFileSpinner />
  ) : (
    <button className={`uploadBtn ${isDisabled}`} type="submit">Upload</button>
  );

  return (
    <form className="selectFile" onSubmit={handeUpload}>
      <input className="selectFileInput" type="file" />
      {uploadButton}
    </form>
  );
};

export default SelectFileInput;